
  <mat-vertical-stepper linear #stepper >
    <mat-step>

        <ng-template matStepLabel>Informations</ng-template>
        <div class="row border">
          <div class="col-md-8 p-4"  *ngIf="type!='gift'">
            <div class="p-1">
              <h3><b>Premium VirtualRacesFrance Participants Receive: </b></h3>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon> 1 Postcard sent from Paris (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Marseille (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Bordeaux (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Nice (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Versailles (France)</h5>
            </div>
            <div  class="p-1">
              <h5><mat-icon >done</mat-icon><b>1 Postcard medal at the end of the race</b></h5>
            </div>
            <div class="p-1">
              <h6>Premium Support</h6>
            </div>
            
            <div>
              <button mat-raised-button class="mt-3 lg-button" color="accent" matStepperNext #myButton>Click here to start <br/>the premium adventure !</button>
            </div>

          </div>

          <div class="col-md-8 p-4"  *ngIf="type=='gift'">
            <div class="p-1">
              <h3><b>Gift card</b></h3>
            </div>
            <div  class="p-1">
              <h5>
                You received a gift card to subscribe to VirtualRacesFrance? Activate your gift code here.
                <br/><br/>
                But first we need you to fill in your adress so we can send your postcard.
              </h5>
            </div>
            
            <div>
              <button mat-raised-button class="mt-3 lg-button" color="accent" matStepperNext #myButton>Click here to use <br/>your gift card !</button>
            </div>
          </div>

          <div class="col-md-4 nopadding">
            <img class="card-img-top" src="../../assets/images/startpayment.jpeg" alt="Card image cap">
          </div>
        </div>
        
       

    </mat-step>
    <mat-step>

        <ng-template matStepLabel>Fill out your address</ng-template>
        <app-address
            (saved)="onSaved($event)">
        </app-address>

        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>

    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Payment</ng-template>
      <app-payment
            [type]="type"
            [address]="address"
            (confirmed)="onConfirmed($event)">
        </app-payment>
      <div>
        <button mat-button matStepperPrevious>Back</button>
      </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Confirmation</ng-template>
        <div class="row p-5" *ngIf="typeConfirmation == 1"> 
          <div class="col-md-12 text-center p-1">
            <h1>Thank You, Merci</h1>
          </div>
          <div class="col-md-12 text-center p-1">
            <h3>Your order has been placed!</h3>
          </div>
          <div class="col-md-12 text-center p-1">
            <h5>
              An email will be sent to you with you order 
              confirmation and receipt. If the email hasn't arrived within 30 minutes, 
              please check your span folder to see if the email was routed there. 
            </h5>
          </div>
        </div>
        <div class="row"> 
          <div class="col-md-12 border text-center p-5">
            <div><mat-icon>local_shipping</mat-icon></div>
            <h4 *ngIf="typeConfirmation == 1">
              You will receive a postcard every time you finish all the steps of a city and a premium card at the end of the adventure !
            </h4>
            <h4 *ngIf="typeConfirmation == 2">
              Congratulations, you will receive a free postcard from Marseille once you have completed all the challenges of Marseille.
            </h4>
            <h4 *ngIf="typeConfirmation == 3">
              You will receive a <b>free</b> postcard every time you finish all the steps of a city and a <b>free</b> premium card at the end of the adventure !
              <br/>
              You are now our <b>ambasador</b>, feel free to share with your community !
            </h4>
            <h6>
              A confimation email will be sent to you.
            </h6>
          </div>
        </div>

        <div>
          <button mat-button  routerLink="/dashboard">Return to Dashboard</button>
        </div>
      </mat-step>
  </mat-vertical-stepper>
  